import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSortDown = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M7.125 4.5V15.885L9.75 13.3463L9.74925 15.3757L6.375 18.75L3.00075 15.3757L3 13.3463L5.625 15.885V4.5H7.125Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21 6H11.25V7.5H21V6Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.4692 9.75H11.25V11.25H19.4692V9.75Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18 13.5H11.25V15H18V13.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.5 17.25H11.25V18.75H16.5V17.25Z",
			fill: "currentColor"
		})
	]
});
export default SvgSortDown;
